var a="/__auth/callback",n=(t="default")=>`/__auth/callback/${t}`,o="/__auth/session",e="/__auth/unauthorized",l="/__auth/logout";export{a,n as b,o as c,e as d,l as e};
